import { render, staticRenderFns } from "./approve-index.vue?vue&type=template&id=06647737&scoped=true"
import script from "./approve-index.vue?vue&type=script&lang=js"
export * from "./approve-index.vue?vue&type=script&lang=js"
import style0 from "./approve-index.vue?vue&type=style&index=0&id=06647737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06647737",
  null
  
)

export default component.exports